import React from "react";
import { Flex } from "@fluentui/react-northstar";
import TaskBoardFilters, { TaskBoardFiltersProps } from "./boardFilters/TaskBoardFilters";
import TaskBoardWeekNavigation, { TaskBoardWeekNavigationProps } from "./boardNavigation/TaskBoardWeekNavigation";
import styles from "./topBar.module.scss";

export interface TaskBoardTopBarProps extends TaskBoardWeekNavigationProps, TaskBoardFiltersProps {}

const TaskBoardTopBar: React.FC<TaskBoardTopBarProps> = (props) => {
    const [showFilters, setShowFilters] = React.useState<boolean>(false);

    return (
        <Flex column className={props.isMobile ? styles.topBarMobile : styles.topBar}>
            <TaskBoardWeekNavigation
                isMobile={props.isMobile}
                disabled={props.disabled}
                range={props.range}
                onBackwardClick={props.onBackwardClick}
                onForwardClick={props.onForwardClick}
                showFilters={showFilters}
                onShowFiltersClick={() => setShowFilters((previousValue) => !previousValue)}
            />
            {showFilters && <TaskBoardFilters isMobile={props.isMobile} disabled={props.disabled} />}
        </Flex>
    );
};

export default TaskBoardTopBar;
